
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewMember"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"researcher"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSuperAdmin"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"memberRole"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memberPermissions"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":153}};
    doc.loc.source = {"body":"fragment ReviewMember on ReviewMember {\n  id\n  researcher {\n    id\n    userId\n    name\n    email\n    isSuperAdmin\n  }\n  memberRole\n  memberPermissions\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
